import { UpgradeTurretMenu } from "./upgrade-turret-menu/UpgradeTurretMenu";
import { BattleManager } from "../BattleManager";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { SelectTurretMenu } from "./select-turret-menu/SelectTurretMenu";
import * as Anuto from "../../../../engine/src";
import { SpecialAttacks } from "./SpecialAttacks";
import { AudioManager } from "../../../AudioManager";
import { GameManager } from "../../../GameManager";
import { CoinsEnemy } from '../board-container/CoinsEnemy';

export class GUI extends Phaser.GameObjects.Container {

    public specialAttacks: SpecialAttacks;

    private menuButton: Phaser.GameObjects.Image;
    private timeStepButton: Phaser.GameObjects.Image;
    private nextWaveButtons: Phaser.GameObjects.Image[];
    private nextWaveTimers: Phaser.GameObjects.Graphics[];
    private selectTurretMenu: SelectTurretMenu;
    private upgradeTurretMenu: UpgradeTurretMenu;

    private nextWaveClicked: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;

        this.nextWaveButtons = [];
        this.nextWaveTimers = [];
        
        if (!this.scene.sys.game.device.os.desktop) {
            this.scaleX = GameVars.scaleX + GameVars.contrascaleX;
        }

        let buttonsContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(buttonsContainer);

        this.menuButton = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 - 45, 45, "texture_atlas_1", "btn_pause_idle");
        this.menuButton.setInteractive();
        this.menuButton.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.menuButton.on("pointerdown", () => { 
            AudioManager.playSound("btn_click");
            this.menuButton.setFrame("btn_pause_pressed");
        });
        this.menuButton.on("pointerup", () => {
            this.onClickMenu(); 
            this.menuButton.setFrame("btn_pause_idle");
        });
        this.menuButton.on("pointerover", () => { 
            this.menuButton.setFrame("btn_pause_over");
        });
        this.menuButton.on("pointerout", () => {
            this.menuButton.setFrame("btn_pause_idle");
        });
        buttonsContainer.add(this.menuButton);

        let offY = (GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2) - (GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2);

        for (let i = 0; i < GameVars.enemiesPathsCells.length; i++) {

            let nextWaveTimer = new Phaser.GameObjects.Graphics(this.scene);
            nextWaveTimer.setPosition(- GameConstants.GAME_WIDTH / 2 + (GameVars.enemiesPathsCells[i].path[1].c + .5) * GameConstants.CELLS_SIZE, offY + (GameVars.enemiesPathsCells[i].path[0].r + .5) * GameConstants.CELLS_SIZE);
            nextWaveTimer.scaleX = (GameVars.enemiesPathsCells[i].path[1].c + .5) * GameConstants.CELLS_SIZE > GameConstants.GAME_WIDTH / 2 ? -1 : 1;
            nextWaveTimer.scaleX *= this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
            buttonsContainer.add(nextWaveTimer);
            this.nextWaveTimers.push(nextWaveTimer);

            let nextWaveButton = new Phaser.GameObjects.Image(this.scene, - GameConstants.GAME_WIDTH / 2 + (GameVars.enemiesPathsCells[i].path[1].c + .5) * GameConstants.CELLS_SIZE, offY + (GameVars.enemiesPathsCells[i].path[0].r + .5) * GameConstants.CELLS_SIZE, "texture_atlas_1", "arrow_enemies");
            nextWaveButton.scaleX = (GameVars.enemiesPathsCells[i].path[1].c + .5) * GameConstants.CELLS_SIZE > GameConstants.GAME_WIDTH / 2 ? -1 : 1;
            nextWaveButton.scaleX *= this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
            nextWaveButton.x += (GameVars.enemiesPathsCells[i].path[1].c + .5) * GameConstants.CELLS_SIZE > GameConstants.GAME_WIDTH / 2 ? -10 : 10;
            nextWaveButton.setInteractive();
            nextWaveButton.on("pointerdown", () => { this.onClickNextWave(i); });
            buttonsContainer.add(nextWaveButton);
            this.nextWaveButtons.push(nextWaveButton);   
            
            if (GameVars.gameData.initialTutorial) {
                nextWaveButton.visible = false;
            }
        }  

        this.timeStepButton = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 - 45, GameConstants.GAME_HEIGHT - 45, "texture_atlas_1", "btn_arrow");
        this.timeStepButton.setInteractive();
        this.timeStepButton.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.timeStepButton.on("pointerdown", () => { 
            AudioManager.playSound("btn_click");
            this.onClickTimeStep(); 
        });
        this.timeStepButton.on("pointerover", () => { 
            this.timeStepButton.setScale(this.scene.sys.game.device.os.desktop ? 1.05 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX * 1.05, 1.05);
        });
        this.timeStepButton.on("pointerout", () => { 
            this.timeStepButton.setScale(this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX, 1);
        });
        buttonsContainer.add(this.timeStepButton);

        this.specialAttacks = new SpecialAttacks(this.scene);
        this.add(this.specialAttacks);

        this.selectTurretMenu = new SelectTurretMenu(this.scene);
        this.add(this.selectTurretMenu);

        this.upgradeTurretMenu = new UpgradeTurretMenu(this.scene);
        this.add(this.upgradeTurretMenu);

        if (GameConstants.DEVELOPMENT) {

            const levelsEditorBtn = new Phaser.GameObjects.Graphics(this.scene);
            levelsEditorBtn.setPosition(60 - GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 30);
            levelsEditorBtn.scaleX = GameVars.scaleX;
            levelsEditorBtn.fillStyle(0xffffff);
            levelsEditorBtn.fillRoundedRect(-50, -20, 100, 40, 5);
            levelsEditorBtn.setInteractive(new Phaser.Geom.Rectangle(-50, -20, 100, 40), Phaser.Geom.Rectangle.Contains);
            levelsEditorBtn.on("pointerdown", this.onClickLevelEditor, this);
            this.add(levelsEditorBtn);

            const levelsEditorLabel = new Phaser.GameObjects.Text(this.scene, 60 - GameConstants.GAME_WIDTH / 2,  GameConstants.GAME_HEIGHT - 30,  "LEVELS\nEDITOR", {fontFamily: "Rubik-Regular", fontSize: "16px", color: "#563744", align: "center"});
            levelsEditorLabel.setOrigin(.5);
            levelsEditorLabel.scaleX = GameVars.scaleX;
            this.add(levelsEditorLabel);

            const killAllEnemiesBtn = new Phaser.GameObjects.Graphics(this.scene);
            killAllEnemiesBtn.setPosition(180 - GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 30);
            killAllEnemiesBtn.scaleX = GameVars.scaleX;
            killAllEnemiesBtn.fillStyle(0xffffff);
            killAllEnemiesBtn.fillRoundedRect(-50, -20, 100, 40, 5);
            killAllEnemiesBtn.setInteractive(new Phaser.Geom.Rectangle(-50, -20, 100, 40), Phaser.Geom.Rectangle.Contains);
            killAllEnemiesBtn.on("pointerdown", this.onClickKillAllWaveEnemies, this);
            this.add(killAllEnemiesBtn);

            const killAllEnemiesLabel = new Phaser.GameObjects.Text(this.scene, 180 - GameConstants.GAME_WIDTH / 2,  GameConstants.GAME_HEIGHT - 30,  "KILL ALL\nENEMIES", {fontFamily: "Rubik-Regular", fontSize: "16px", color: "#563744", align: "center"});
            killAllEnemiesLabel.setOrigin(.5);
            killAllEnemiesLabel.scaleX = GameVars.scaleX;
            this.add(killAllEnemiesLabel);

            const saveTurretsBtn = new Phaser.GameObjects.Graphics(this.scene);
            saveTurretsBtn.setPosition(300 - GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 30);
            saveTurretsBtn.scaleX = GameVars.scaleX;
            saveTurretsBtn.fillStyle(0xffffff);
            saveTurretsBtn.fillRoundedRect(-50, -20, 100, 40, 5);
            saveTurretsBtn.setInteractive(new Phaser.Geom.Rectangle(-50, -20, 100, 40), Phaser.Geom.Rectangle.Contains);
            saveTurretsBtn.on("pointerdown", this.onClickSaveTurrets, this);
            this.add(saveTurretsBtn);

            const saveTurretsLabel = new Phaser.GameObjects.Text(this.scene, 300 - GameConstants.GAME_WIDTH / 2,  GameConstants.GAME_HEIGHT - 30,  "SAVE\nTURRETS", {fontFamily: "Rubik-Regular", fontSize: "16px", color: "#563744", align: "center"});
            saveTurretsLabel.setOrigin(.5);
            saveTurretsLabel.scaleX = GameVars.scaleX;
            this.add(saveTurretsLabel);
        }
    }

    public update(time: number, delta: number): void {

        this.specialAttacks.update(time, delta);

        if (BattleManager.anutoEngine.initialTimer < BattleManager.anutoEngine.initialTicksTimer && !BattleManager.anutoEngine.gameOver) {

            let angle = (BattleManager.anutoEngine.initialTimer / BattleManager.anutoEngine.initialTicksTimer) * 360 - 90;

            for (let i = 0; i < this.nextWaveTimers.length; i++) {
                this.nextWaveTimers[i].visible = true;
                this.nextWaveTimers[i].clear();
                this.nextWaveTimers[i].fillStyle(0xF5233F);
                this.nextWaveTimers[i].slice((GameVars.enemiesPathsCells[i].path[1].c + .5) * GameConstants.CELLS_SIZE > GameConstants.GAME_WIDTH / 2 ? -15 : 15, 0, 40, Phaser.Math.DegToRad(-90), Phaser.Math.DegToRad(angle));
                this.nextWaveTimers[i].fillPath();
            }
        
        } else {
            for (let i = 0; i < this.nextWaveTimers.length; i++) {
                this.nextWaveTimers[i].visible = false;
            }
        }
    }

    public showSelectTurret(c: number, r: number): void {

        let offX = - GameConstants.CELLS_SIZE * (GameVars.currentMapData.size.c / 2);
        let offY = (GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2) - GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2 ;

        this.selectTurretMenu.show(c, r);
        this.selectTurretMenu.x = offX + ((c + .5) * GameConstants.CELLS_SIZE);
        this.selectTurretMenu.y = offY + (r + .5) * GameConstants.CELLS_SIZE;
    }

    public hideSelectTurret(): void {

        this.selectTurretMenu.hide();
    }

    public showTurretMenu(anutoTurret: Anuto.Turret): void {

        let offX = - GameConstants.CELLS_SIZE * (GameVars.currentMapData.size.c / 2);
        let offY = (GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2) - GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2;

        this.upgradeTurretMenu.show(anutoTurret);
        this.upgradeTurretMenu.x = offX + ((anutoTurret.position.c + .5) * GameConstants.CELLS_SIZE);
        this.upgradeTurretMenu.y = offY + (anutoTurret.position.r + .5) * GameConstants.CELLS_SIZE;
    }

    public hideTurretMenu(): void {

        this.upgradeTurretMenu.hide();
    }

    public activeNextWave(): void {

        for (let i = 0; i < this.nextWaveButtons.length; i++) {
            this.nextWaveButtons[i].visible = true;
        }

        for (let i = 0; i < this.nextWaveTimers.length; i++) {
            this.nextWaveTimers[i].visible = true;
        }
    }

    public hideNextWave(): void {

        for (let i = 0; i < this.nextWaveButtons.length; i++) {
            this.nextWaveButtons[i].visible = false;
        }

        for (let i = 0; i < this.nextWaveTimers.length; i++) {
            this.nextWaveTimers[i].visible = false;
        }
    }

    public showExtraCredits(extraCredits: number): void {

        if (this.nextWaveClicked === -1) {
            return;
        }

        this.addExtraCoins(this.nextWaveButtons[this.nextWaveClicked].x + 20, this.nextWaveButtons[this.nextWaveClicked].y - 40, extraCredits);
    }

    public addExtraCoins(x: number, y: number, coins: number): void {

        let coinsEnemy = new CoinsEnemy(this.scene, x, y, coins);
        this.add(coinsEnemy);
    }

    public onClickNextWave(i: number): void {

        this.nextWaveClicked = i;

        if (!this.nextWaveButtons[0].visible || GameVars.paused || BattleManager.anutoEngine.gameOver) {
            return;
        }

        if (i !== -1) {
            AudioManager.playSound("btn_click");
        }
        
        this.hideNextWave();

        BattleManager.newWave(i === -1);
    }

    public onSuicideSoldierAvailable(): void {

        this.specialAttacks.onSuicideSoldierAvailable();
    }

    public onFreezeAttackAvailable(): void {

        this.specialAttacks.onFreezeAttackAvailable();
    }

    private onClickTimeStep(): void {

        if (this.timeStepButton.alpha !== 1 || GameVars.paused) {
            return;
        }

        if (GameVars.timeStepFactor === 1) {
            BattleManager.setTimeStepFactor(4);
            this.timeStepButton.setFrame("btn_arrow_ffwd");
        } else {
            BattleManager.setTimeStepFactor(1);
            this.timeStepButton.setFrame("btn_arrow");
        }
    }

    private onClickMenu(): void {

        if (BattleManager.anutoEngine.gameOver || BattleManager.anutoEngine.win) {
            return;
        }

        BattleManager.onClickMenu();
    }

    private onClickLevelEditor(): void {

        GameManager.enterLevelsEditorScene();
    }

    private onClickKillAllWaveEnemies(): void {

        BattleManager.killAllWaveEnemies();
    }

    private onClickSaveTurrets(): void {

        GameManager.savePreviousTurrets(); 
    }
}
